// extracted by mini-css-extract-plugin
export default {"title":"api-result_title__zCb8p","text":"api-result_text__2jLcc"};